import { ResizeDir } from '../types';

type Props = {
  makeResizeHandler: (dir: ResizeDir) => (e: React.MouseEvent) => void;
};

const handle = (
  style: React.CSSProperties,
  zIndex: number,
  onMouseDown: (e: React.MouseEvent) => void,
) => (
  <div
    style={{ position: 'absolute', zIndex, ...style }}
    onMouseDown={onMouseDown}
  />
);

const ResizeHandles = ({ makeResizeHandler }: Props) => (
  <>
    {handle(
      { top: 0, left: 8, right: 8, height: 6, cursor: 'n-resize' },
      10,
      makeResizeHandler('n'),
    )}
    {handle(
      { bottom: 0, left: 8, right: 8, height: 6, cursor: 's-resize' },
      10,
      makeResizeHandler('s'),
    )}
    {handle(
      { right: 0, top: 8, bottom: 8, width: 6, cursor: 'e-resize' },
      10,
      makeResizeHandler('e'),
    )}
    {handle(
      { left: 0, top: 8, bottom: 8, width: 6, cursor: 'w-resize' },
      10,
      makeResizeHandler('w'),
    )}
    {handle(
      { top: 0, left: 0, width: 10, height: 10, cursor: 'nw-resize' },
      11,
      makeResizeHandler('nw'),
    )}
    {handle(
      { top: 0, right: 0, width: 10, height: 10, cursor: 'ne-resize' },
      11,
      makeResizeHandler('ne'),
    )}
    {handle(
      { bottom: 0, left: 0, width: 10, height: 10, cursor: 'sw-resize' },
      11,
      makeResizeHandler('sw'),
    )}
    {handle(
      { bottom: 0, right: 0, width: 18, height: 18, cursor: 'se-resize' },
      11,
      makeResizeHandler('se'),
    )}
  </>
);

export default ResizeHandles;
